import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { AuthRoutes } from '../enums';

const authUrl = process.env.REACT_APP_AUTH_URL ?? '';
const appUrl = `${window.location.protocol}//${window.location.host}`;
const identityUrl = authUrl.replace(/\/$/, '');

const scopes = [
  'openid',
  'profile',
  process.env.REACT_APP_AUTH_API ?? '',
  'Permission',
  'Roles',
  'User',
  'offline_access'
];

export const userManagerSettings: UserManagerSettings = {
  // (string): The URL of the OIDC provider.
  authority: identityUrl,
  automaticSilentRenew: true, // (boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
  loadUserInfo: false, // (boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  redirect_uri: `${appUrl}${AuthRoutes.SigninCallback}`, // The URI of your client application to receive a response from the OIDC provider.
  silent_redirect_uri: `${appUrl}${AuthRoutes.SigninSilentCallback}`, // (string): The URL for the page containing the code handling the silent renew.
  post_logout_redirect_uri: `${appUrl}${AuthRoutes.LogoutCallback}`, // (string): The OIDC post-logout redirect URI.
  response_type: 'code', // (string, default: 'id_token'): The type of response desired from the OIDC provider.
  scope: scopes.join(' '), // (string, default: 'openid'): The scope being requested from the OIDC provider.
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID ?? '',
  client_secret: process.env.REACT_APP_IDENTITY_CLIENT_SECRET ?? '',
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  metadata: {
    issuer: identityUrl,
    jwks_uri: `${identityUrl}/.well-known/openid-configuration/jwks`,
    authorization_endpoint: `${identityUrl}/connect/authorize`,
    token_endpoint: `${identityUrl}/connect/token`,
    userinfo_endpoint: `${identityUrl}/connect/userinfo`,
    end_session_endpoint: `${identityUrl}/connect/endsession`,
    check_session_iframe: `${identityUrl}/connect/checksession`,
    revocation_endpoint: `${identityUrl}/connect/revocation`,
    introspection_endpoint: `${identityUrl}/connect/introspect`,
    grant_types_supported: ['code'],
    response_types_supported: ['code']
  },
  silentRequestTimeoutInSeconds: 3,
  includeIdTokenInSilentRenew: true,
  monitorSession: false,
  checkSessionIntervalInSeconds: 60
};

export const signoutUrl = `${identityUrl}/account/logout?callbackUrl=${appUrl}${AuthRoutes.LogoutCallback}`;
